module.exports = __webpack_public_path__ + "static/media/react_logo.4ade5cac.png";